import React from 'react';
import moment from "moment";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

export default class FormViewer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loaded: true,
            message: "",
            isAdmin: false,
            isOrgAdmin: false,
            formData: {
                formID: this.props.id,
                formName: "",
                formDescription: "",
                username: "",
                organization: "",
                dateCompleted: "",
                formSections: []
            }
        }
    }
    componentDidMount() {
        if (this.props.id !== 0)
            this.loadForm();
    }
    loadForm() {
        this.setState({ loaded: false }, () => {
            this.props.api.send({
                controller: "Form",
                action: "GetCompletedForm",
                method: "post",
                body: JSON.stringify({ completedformID: this.props.id }),
                success: (result) => {
                    console.log(result);
                    // FLATTEN
                    for (var s = 0; s < result.form.formSections.length; s++) {
                        var section = result.form.formSections[s];
                        for (var fi = 0; fi < section.formItems.length; fi++) {
                            var formItem = section.formItems[fi];
                            if (formItem.itemType === 7) {
                                var flatten = [];
                                this.flattenListItem(flatten, formItem.itemDropDownItem);
                                formItem["itemDropDownItemsFlattened"] = flatten;
                            }
                        }
                    }

                    this.setState({
                        loaded: true,
                        isAdmin: result.isAdmin,
                        isOrgAdmin: result.isOrgAdmin,
                        formData: result.form
                    });
                },
                error: (err) => {
                    this.setState({ loaded: true });
                }
            })
        });
    }

    flattenListItem(flattened, formItem) {
        flattened.push({ name: formItem.name, value: formItem.value });
        if (formItem.linkedCompletedListItem !== null) {
            this.flattenListItem(flattened, formItem.linkedCompletedListItem)
        } else {
            return;
        }
    }

    // ADMIN CONTROL FORM INPUT HANDLERS
    completeSectionItem(e, index, itemIndex, itemType) {
        let form = this.state.formData;
        if (index >= 0) {
            form.formSections[index].formItems[itemIndex].itemValue = (
                itemType === 0 ? e.target.value
                    : itemType === 1 ? e.target.nextSibling.wholeText.trim()
                        : itemType === 2 ? e.target.value
                            : itemType === 3 ? e._d
                                : itemType === 6 ? e.target.nextSibling.wholeText.trim() : ""
            );
        }
        this.setState({ formData: form });
    }
    completeSectionItemListItem(e, index, itemIndex, itemListIndex, itemType) {
        let form = this.state.formData;
        let item = form.formSections[index].formItems[itemIndex];
        if (!item.itemValues)
            item.itemValues = [];

        if (index >= 0) {
            let listItem = item.itemList[itemListIndex];
            let listItemID = listItem.completedListItemID

            if (item.itemType === 4) // Clear Exclusive.
                item.itemList.map(i => i.itemSelected = false);
            item.itemList[itemListIndex].itemSelected = e.target.checked;
            if (e.target.checked) {
                if (itemType === 4) { // Exclusive list
                    item.itemValues = [listItemID];
                    if (listItem.itemType !== 2) {
                        item.itemMeta = ""; // Purge item meta if other(2) is not selected (exclusive).
                    }
                } else {
                    item.itemValues.push(listItemID);
                }
            } else {
                if (listItem.itemType === 2) {
                    item.itemMeta = ""; // Purge item meta if other(2) is unchecked.
                }
                // remove from values if present. 
                let values = item.itemValues
                values.splice(values.indexOf(listItemID), 1);
                item.itemValues = values;
            }
        }
        this.setState({ formData: form });
    }
    downloadAttachment(e, index, itemIndex) {
        let form = this.state.formData;
        let item = form.formSections[index].formItems[itemIndex];
        if (item.itemAttachmentID > 0) {
            this.props.api.download({
                controller: "Form",
                action: "GetFormItemFile/?attachmentID=" + item.itemAttachmentID,
                method: "get",
                attachmentName: item.itemAttachmentName
            })
        }
    }
    submitAdminReview() {
        this.setState({ loaded: false }, () => {
            this.props.api.send({
                controller: "Form",
                action: "SubmitAdminReviewForm",
                method: "post",
                body: JSON.stringify(this.state.formData),
                success: (result) => {
                    console.log(result);
                    if (result.success === true) {
                        this.setState({
                            loaded: true
                        });
                        this.loadForm();
                    }
                },
                error: (err) => {
                    this.setState({ loaded: true });
                }
            })
        });
    }

    render() {
        const isAdmin = this.state.isAdmin;
        const isOrgAdmin = this.state.isOrgAdmin;

        var tempStyle = {
            'backgroundColor': 'white',
            'width': '100%',
            'display': 'block'
        }
        var tempStyle2 = {
            'backgroundColor': '#195577',
            'color': 'white',
            'borderRadius': '5px'
        }
        var tempStyle3 = {
            'color': 'black',
        }
        return this.state.loaded ? (
            <div style={tempStyle}>
                <div className="lmsbanner">
                    <div className="lmstopleft">
                        <h1 className="lmsheadertxt">Safety Check</h1>
                        <div className="lmspoweredby">Powered by<br />
                            <a className="bodylink" href="https://www.csem.com">
                                <img src="/images/logo.png" alt="CSEM" />
                            </a>
                        </div>
                    </div>
                    <div className="lmstopright">
                        <strong> {this.state.formData.organization.organizationName}</strong>
                        <br></br>
                        {this.state.formData.organization.address1}
                        <br></br>
                        {this.state.formData.organization.city}, {this.state.formData.organization.state}, {this.state.formData.organization.zipcode}
                        <br></br>
                        <strong> {this.state.formData.username}</strong>
                        <br></br>
                        <strong> {this.state.formData.dateCompleted}</strong>

                    </div>
                </div>
                <div className="lmsformheading">
                    <h2> {this.state.formData.formName} </h2>
                    <label className="lmsformlabel" style={{ width: "auto" }}>{this.state.formData.formDescription}</label>
                </div>
                <br>
                </br>

                {this.state.formData.formSections.map((section, secidx) =>
                    <div>
                        {!section.admin || (section.admin && section.adminReviewed && (isAdmin || isOrgAdmin)) ? (
                            <div key={secidx} className="lmsform">
                                <div className="lmsformheading">
                                    <h3>{section.name}</h3>
                                    <hr></hr>
                                    <p>{section.description}</p>
                                    {section.formItems.map((item, itemidx) =>
                                        <div key={itemidx} className="lmsformitem">
                                            <label className="lmsformlabel" style={{ width: "auto" }}>{item.itemText} </label>
                                            <div style={tempStyle2}>
                                                {item.itemType === 0 ? (
                                                    <label className="lmsformlabel" style={{ width: "auto" }}>{item.itemValue} </label>
                                                ) : item.itemType === 1 ? (
                                                    <div className="form-radiobutton-container">
                                                        <div className="lmsradiobuttons">
                                                            <input type="radio" name={"formRbtn_" + item.itemID}
                                                                checked={item.itemValue === "OK"}
                                                                readOnly
                                                            /> OK
                                                        </div>
                                                        <div className="lmsradiobutton">
                                                            <input type="radio" name={"formRbtn_" + item.itemID}
                                                                checked={item.itemValue === "Repairs Required"}
                                                                readOnly
                                                            /> Repairs Required
                                                        </div>
                                                    </div>
                                                ) : item.itemType === 2 ? (
                                                    <label className="lmsformlabel" style={{ width: "auto" }}>{item.itemValue} </label>
                                                ) : item.itemType === 3 ? (
                                                    <label className="lmsformlabel" style={{ width: "auto" }}>{item.itemValue} </label>
                                                ) : item.itemType === 4 ? (
                                                    <div className="form-radiobutton-container">
                                                        {item.itemList.map((listItem, listItemIdx) =>
                                                            <div key={listItemIdx} className="lmsradiobutton">
                                                                <label>
                                                                    <input type="radio"
                                                                        id={item.itemID}
                                                                        checked={listItem.itemSelected === true}
                                                                        readOnly
                                                                    /> {listItem.itemText}
                                                                </label>
                                                            </div>
                                                        )}
                                                    </div>
                                                ) : item.itemType === 5 ? (
                                                    <div className="form-radiobutton-container">
                                                        {item.itemList.map((listItem, listItemIdx) =>
                                                            <div key={listItemIdx} className="lmsradiobutton">
                                                                <label>
                                                                    <input type="checkbox"
                                                                        name={"formChk_" + item.itemID}
                                                                        id={item.itemID}
                                                                        checked={listItem.itemSelected === true}
                                                                        onChange={null}
                                                                        readOnly
                                                                    /> {listItem.itemText}
                                                                </label>
                                                            </div>
                                                        )}
                                                    </div>
                                                ) : item.itemType === 6 ? (
                                                    <div className="form-radiobutton-container">
                                                        <div className="lmsradiobuttons">
                                                            <input type="radio" name={"formRbtn_" + item.itemID}
                                                                checked={item.itemValue === "Agree"}
                                                                readOnly
                                                            /> Agree
                                                        </div>
                                                        <div className="lmsradiobutton">
                                                            <input type="radio" name={"formRbtn_" + item.itemID}
                                                                checked={item.itemValue === "Disagree"}
                                                                readOnly
                                                            /> Disagree
                                                        </div>
                                                    </div>
                                                ) : item.itemType === 7 ? (
                                                    <table className="lmstable">
                                                        <tbody>
                                                            <tr>
                                                                {item.itemDropDownItemsFlattened.map((ddItem, ddIndex) =>
                                                                    <React.Fragment key={ddIndex}>
                                                                        <th>List Item {ddIndex}</th>
                                                                    </React.Fragment>
                                                                )}
                                                            </tr>
                                                            <tr style={tempStyle3}>
                                                                {item.itemDropDownItemsFlattened.map((ddItem, ddIndex) =>
                                                                    <React.Fragment key={ddIndex}>
                                                                        <td>{ddItem.name}</td>
                                                                    </React.Fragment>
                                                                )}
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                ) : item.itemType === 8 ? (
                                                    <div>
                                                        <label className="lmsformlabel" style={{ width: "auto" }}>{item.itemValue}</label>
                                                    </div>
                                                ) : item.itemType === 9 ? (
                                                    <div>
                                                        <label className="lmsformlabel-signature-date">{item.itemSignatureDate} </label>
                                                        <label className="lmsformlabel-signature" style={{ fontFamily: item.itemSignatureFont }}>{item.itemSignatureText} </label>
                                                        <label className="lmsformlabel-signature-hash">{item.itemSignatureHash} </label>
                                                    </div>
                                                ) : (null)}

                                                {item.itemAttachmentID !== null ? (
                                                    <div style={{ backgroundColor: "#f5f5f5", color: "black" }}>
                                                        <div>Attachments:</div>
                                                        <label className="lmsformlabel" style={{ width: "auto" }}>{item.itemAttachmentName} </label>
                                                        <input type="button" className="lmsbutton" value="Download" onClick={(e) => this.downloadAttachment(e, secidx, itemidx)} />
                                                    </div>
                                                ) : null}
                                            </div>
                                            {item.itemMeta !== null && item.itemMeta !== "" ? (
                                                <div style={{ marginTop: "10px", border: "1px solid #222222", borderRadius: "6px", padding: "8px" }}>
                                                    {item.itemMeta}
                                                </div>
                                            ) : null}
                                        </div>
                                    )}
                                </div>
                            </div>
                        ) : isAdmin || isOrgAdmin ? (
                            <div className="lmsform" key={secidx}>
                                <div className="lmsformheading">
                                    <h3>{section.name}</h3>
                                    <hr></hr>
                                    <p>{section.description}</p>
                                    {section.formItems.map((item, itemidx) =>
                                        <div style={{ fontWeight: "bold" }} key={itemidx}>
                                            <div className="lmsformitem">
                                                <label className="lmsformlabel">{item.itemText}</label>
                                                {item.itemType === 0 ? (
                                                    <input type="text" className="lmsforminput"
                                                        name={"formText_" + item.itemID}
                                                        id={item.itemID}
                                                        value={item.itemValue}
                                                        onChange={(e, index, itemType) => this.completeSectionItem(e, secidx, itemidx, item.itemType)}
                                                    />
                                                ) : item.itemType === 1 ? (
                                                    <div className="form-radiobutton-container">
                                                        <div className="lmsradiobuttons">
                                                            <label>
                                                                <input type="radio"
                                                                    name={"formRbtn_" + item.itemID}
                                                                    onClick={(e, index, itemType) => this.completeSectionItem(e, secidx, itemidx, item.itemType)}
                                                                    checked={item.itemValue === "Repairs Required"}
                                                                /> OK
                                                            </label>
                                                        </div>
                                                        <div className="lmsradiobutton">
                                                            <label>
                                                                <input type="radio"
                                                                    name={"formRbtn_" + item.itemID}
                                                                    onClick={(e, index, itemType) => this.completeSectionItem(e, secidx, itemidx, item.itemType)}
                                                                    checked={item.itemValue === "Repairs Required"}
                                                                /> Repairs Required
                                                            </label>
                                                        </div>
                                                    </div>
                                                ) : item.itemType === 2 ? (
                                                    <textarea type="text" className="lmsforminput"
                                                        name={"formTextArea_" + item.itemID}
                                                        id={item.itemID}
                                                        value={item.itemValue}
                                                        onChange={(e, index, itemType) => this.completeSectionItem(e, secidx, itemidx, item.itemType)}
                                                    />
                                                ) : item.itemType === 3 ? (
                                                    <DatePicker showTimeSelect name={this.props.name}
                                                        className="lmsforminput"
                                                        timeFormat="HH:mm" dateFormat="MM/DD/YYYY HH:mm"
                                                        id={item.itemID.toString()}
                                                        timeIntervals={5}
                                                        selected={item.itemValue !== '' ? moment(item.itemValue) : null}
                                                        startDate={item.itemValue !== '' ? moment(item.itemValue) : null}
                                                        onChange={(e, index, itemType) => this.completeSectionItem(e, secidx, itemidx, item.itemType)}
                                                    />
                                                ) : item.itemType === 4 ? (
                                                    <div className="form-radiobutton-container">
                                                        {item.itemList.map((listItem, listItemIdx) =>
                                                            <div key={listItemIdx} className="lmsradiobutton">
                                                                <label>
                                                                    <input type="radio"
                                                                        name={"formRbtn_" + item.itemID}
                                                                        id={item.itemID}
                                                                        onChange={(e, index, itemIndex, itemListIndex, itemType) => this.completeSectionItemListItem(e, secidx, itemidx, listItemIdx, item.itemType)}
                                                                        checked={listItem.itemSelected}
                                                                    /> {listItem.itemText}
                                                                </label>
                                                            </div>
                                                        )}
                                                    </div>
                                                ) : item.itemType === 5 ? (
                                                    <div className="form-radiobutton-container">
                                                        {item.itemList.map((listItem, listItemIdx) =>
                                                            <div key={listItemIdx} className="lmsradiobutton">
                                                                <label>
                                                                    <input type="checkbox"
                                                                        name={"formChk_" + item.itemID}
                                                                        id={item.itemID}
                                                                        onChange={(e, index, itemIndex, itemListIndex, itemType) => this.completeSectionItemListItem(e, secidx, itemidx, listItemIdx, item.itemType)}
                                                                        checked={listItem.itemSelected}
                                                                    /> {listItem.itemText}
                                                                </label>
                                                            </div>
                                                        )}
                                                    </div>
                                                ) : item.itemType === 6 ? (
                                                    <div className="lmsformitem">
                                                        <iframe src={item.itemFilePreview} type="application/pdf" width="100%" height="600px" title="Form Item" ></iframe>
                                                        <div className="lmsradiobutton">
                                                            <label>
                                                                <input type="radio"
                                                                    name={"formRbtn_" + item.itemID}
                                                                    id={item.itemID}
                                                                    onClick={(e, index, itemType) => this.completeSectionItem(e, secidx, itemidx, item.itemType)}
                                                                    checked={item.itemValue === "Agree"}
                                                                /> Agree
                                                            </label>

                                                            <label>
                                                                <input type="radio"
                                                                    name={"formRbtn_" + item.itemID}
                                                                    id={item.itemID}
                                                                    onClick={(e, index, itemType) => this.completeSectionItem(e, secidx, itemidx, item.itemType)}
                                                                    checked={item.itemValue === "Disagree"}
                                                                /> Disagree
                                                            </label>
                                                        </div>
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                    )}
                                    <div className="lmscenter">
                                        <input type="button" className="lmsbutton" value="Submit" onClick={() => this.submitAdminReview()} />
                                    </div>
                                </div>
                            </div>
                        ) : <div></div>}
                    </div>
                )}
            </div>
        ) : (
                <div className="lmscenter"><img src="/images/spinner.svg" alt="Loading..." /></div>
            )
    }
}


// WEBPACK FOOTER //
// ./src/forms/formviewer.js